import { render, staticRenderFns } from "./Relate.vue?vue&type=template&id=62cd5843&scoped=true&"
import script from "./Relate.vue?vue&type=script&lang=js&"
export * from "./Relate.vue?vue&type=script&lang=js&"
import style0 from "./Relate.vue?vue&type=style&index=0&id=62cd5843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd5843",
  null
  
)

export default component.exports